<div class="filters" cdkDropList cdkDropListOrientation="horizontal" [cdkDropListConnectedTo]="[deleteArea]" cdkDropListLockAxis="x"
  (cdkDropListDropped)="onDropPosFilter($event)">
  <div class="filter-tabs">
    <div *ngFor="let filter of getShowFilters()" class="filter-tab">
      <button cdkDrag [cdkDragData]="filter" class="btn btn-filter btn-filter-primary dropdown-toggle" [dropdown]="dropdownContent"
        (onDropdownShow)="onShowFilter(filter, dropdownContent)" [tooltip]="filter.value ? filter.value : ''" tooltipPlacement="bottom">
        <i class="icon-drag-indicator"></i> {{ filter.title }} <span *ngIf="filter.value">: {{ filter.value }}</span>
      </button>
      <ng-template #dropdownContent let-dr="dropdown">
        <div [ngSwitch]="filter.title" class="dropdown-menu px-0 py-10 rounded-15 bg-neutral-n1">
          <div *ngSwitchCase="'Date'">
            <div class="date-filter-drop mx-15">
              <input-search-period type="date" [autoApply]="false" (change)="onChangeFilterValue($event.start === null ? '' : $event, filter);dr.hide();"
                [placeholder]="'Date'"></input-search-period>
            </div>
          </div>
          <div *ngSwitchCase="'Phone'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <input [(ngModel)]="model.phoneNumbers" class="form-control" type="text" [ngModelOptions]="{standalone: true}">
            </div>
            <hr>
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter);dr.hide();">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.phoneNumbers, filter);dr.hide();">Submit</button>
            </div>
          </div>
          <div *ngSwitchCase="'Amount'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
            </div>
            <div class="d-flex mx-10 range-inputs">
              <div class="min-input">
                <label>Min</label>
                <input type="number" step="0.1" [(ngModel)]="model.amountMin" class="form-control" [ngModelOptions]="{standalone: true}">
              </div>
              <div class="max-input">
                <label>Max</label>
                <input type="number" step="0.1" [(ngModel)]="model.amountMax" class="form-control" [ngModelOptions]="{standalone: true}">
              </div>
            </div>
            <hr>
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter);dr.hide();">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue({min: model.amountMin, max: model.amountMax}, filter);dr.hide();">Submit</button>
            </div>
          </div>
          <div *ngSwitchCase="'Payment method'">
            <div class="d-flex justify-content-end me-10">
              <span class="cp text-neutral-n7 status-text text-decoration-underline" (click)="onChangeFilterValue('', filter);dr.hide();">Clear</span>
            </div>
            <div class="mx-10">
              <div *ngFor="let p of paymentMethods" class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangeFilterValue(p.name, filter);">
                <div class="input-check">
                  <input type="checkbox" class="form-check-input" [checked]="p.name === model.paymentMethodName" />
                </div>
                <span>{{ p.name }}</span>
              </div>
            </div>
          </div>
          <div *ngSwitchCase="'Payment address'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <input [(ngModel)]="model.paymentAddress" class="form-control" type="text" [ngModelOptions]="{standalone: true}">
            </div>
            <hr>
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter);dr.hide();">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.paymentAddress, filter);dr.hide();">Submit</button>
            </div>
          </div>
          <div *ngSwitchCase="'Email'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <input [(ngModel)]="model.email" class="form-control" type="text" [ngModelOptions]="{standalone: true}">
            </div>
            <hr>
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter);dr.hide();">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.email, filter);dr.hide();">Submit</button>
            </div>
          </div>

          <div *ngSwitchCase="'Status'">
            <div class="d-flex justify-content-end me-10">
              <span class="cp text-neutral-n7 status-text text-decoration-underline" (click)="onChangeFilterValue('', filter);dr.hide();">Clear</span>
            </div>
            <div class="mx-10">
              <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangeFilterValue('PENDING', filter);">
                <div class="input-check">
                  <input type="checkbox" class="form-check-input" [checked]="model.statuses.includes('PENDING')" />
                </div>
                <span>Pending</span>
              </div>
              <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangeFilterValue('PROCESSING', filter);">
                <div class="input-check">
                  <input type="checkbox" class="form-check-input" [checked]="model.statuses.includes('PROCESSING')" />
                </div>
                <span>Processing</span>
              </div>
              <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangeFilterValue('PAYMENT_SENT', filter);">
                <div class="input-check">
                  <input type="checkbox" class="form-check-input" [checked]="model.statuses.includes('PAYMENT_SENT')" />
                </div>
                <span>Payment sent</span>
              </div>
              <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangeFilterValue('PAID', filter);">
                <div class="input-check">
                  <input type="checkbox" class="form-check-input" [checked]="model.statuses.includes('PAID')" />
                </div>
                <span>Paid</span>
              </div>
              <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangeFilterValue('FAILED', filter);">
                <div class="input-check">
                  <input type="checkbox" class="form-check-input" [checked]="model.statuses.includes('FAILED')" />
                </div>
                <span>Failed</span>
              </div>
            </div>
          </div>

          <div *ngSwitchCase="'Autopay'">
            <div class="mx-10">
              <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangeFilterValue(true, filter);">
                <div class="input-check">
                  <input type="checkbox" class="form-check-input" [checked]="model.withdrawalAvailable === true" />
                </div>
                <span>Enabled</span>
              </div>
              <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangeFilterValue(false, filter);">
                <div class="input-check">
                  <input type="checkbox" class="form-check-input" [checked]="model.withdrawalAvailable === false" />
                </div>
                <span>Disabled</span>
              </div>
            </div>
          </div>


        </div>
      </ng-template>
    </div>
  </div>
  <div class="filter-controls">
    <button class="btn btn-filter filter-add-btn" [disabled]="!getHiddenFilters().length" [dropdown]="hiddenFilters">
      <i class="icon-add"></i> Add Filter
    </button>
    <ng-template #hiddenFilters let-dr="dropdown">
      <ul class="dropdown-menu rounded-15 bg-neutral-n1">
        <li *ngFor="let filter of getHiddenFilters()" class="dropdown-item filter-item px-15 py-10" (click)="onClickShowFilter(filter, dr)">
          <a>{{ filter.title }}</a>
        </li>
      </ul>
    </ng-template>
    <button cdkDropList cdkDropListLockAxis="x" #deleteArea="cdkDropList" (cdkDropListDropped)="onDropFilter($event)" class="btn btn-filter delete-area"
      (click)="resetFilters()">
      <i class="far fa-trash-alt"></i> Clear
    </button>
  </div>
</div>
